let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fKeR9")).then(() => parcelRequire('6a8CY'));